import React from "react";

interface IProps {
  minCount: number;
  value: number;
  onChange: (value: number) => void;
  delta?: number;
}

const Counter: React.SFC<IProps> = ({ minCount, value, onChange, delta = 1 }) => {
  const handleChangeIncrease = () => {
    onChange(value + delta);
  };

  const handleChangeReduce = () => {
    let newValue;
    if (value !== minCount) {
      newValue = value - delta;
    } else {
      newValue = value;
    }
    onChange(newValue);
  };

  return (
    <div className="par">
      <button className="num_red" onClick={handleChangeReduce}>
        -
      </button>
      <input type="number" value={value} readOnly={true} />
      <button className="num_inc" onClick={handleChangeIncrease}>
        +
      </button>
    </div>
  );
};

export default Counter;
